import { HeartPulse } from "lucide-react";

// CertIVSims wordmark (per uploaded CertIVSims-Logo.png). Two colour variants:
//  • Dark background (default): "Cert" #94A3B8 · "IV" #2dd4d8 · "Sims" #F8FAFC, with glow.
//  • Light background (`chip`): "Cert" #4A5560 · "IV"/accents #00D2E6 · "Sims" #2D3135,
//    rendered directly on the light surface (no dark pill, no glow) for high contrast.
// The wordmark splits into two groups so the scan lines match the artwork exactly:
// a line from the bottom of the "I" UNDERLINES "Cert", and a line from the top of
// the "V" OVERLINES "Sims". A HeartPulse mark sits before the wordmark.
const DARK = { cert: "#94A3B8", iv: "#2dd4d8", sims: "#F8FAFC" };
const LIGHT = { cert: "#4A5560", iv: "#00D2E6", sims: "#2D3135" };

export const BrandLogo = ({ className = "", chip = false, showIcon = true }) => {
  const light = chip; // light-background variant
  const c = light ? LIGHT : DARK;

  const bar = light
    ? { backgroundColor: c.iv }
    : { backgroundColor: c.iv, boxShadow: "0 0 6px rgba(45,212,216,0.85)" };
  const ivStyle = light
    ? { color: c.iv }
    : { color: c.iv, textShadow: "0 0 10px rgba(45,212,216,0.5)" };
  const iconStyle = light
    ? { color: c.iv }
    : { color: c.iv, filter: "drop-shadow(0 0 5px rgba(45,212,216,0.55))" };

  return (
    <span
      className={`inline-flex items-center gap-1.5 leading-none select-none ${className}`}
      style={{ fontFamily: "'Instrument Sans', ui-sans-serif, system-ui, sans-serif" }}
      aria-label="CertIVSims"
      data-testid={light ? "brand-logo-chip" : undefined}
    >
      {showIcon && (
        <HeartPulse
          className="w-[1.2em] h-[1.2em] shrink-0"
          style={iconStyle}
          strokeWidth={2.4}
          aria-hidden="true"
        />
      )}
      <span className="inline-flex items-baseline tracking-tight text-lg">
        {/* Left group: "Cert" + "I" — scan line from the I underlines "Cert" */}
        <span className="relative pb-[3px]">
          <span className="font-medium" style={{ color: c.cert }}>Cert</span>
          <span className="font-bold" style={ivStyle}>I</span>
          <span
            className="absolute left-0 right-0 bottom-0 h-[1.5px] rounded-full"
            style={bar}
            aria-hidden="true"
          />
        </span>
        {/* Right group: "V" + "Sims" — scan line from the V overlines "Sims" */}
        <span className="relative pt-[3px]">
          <span className="font-bold" style={ivStyle}>V</span>
          <span className="font-normal" style={{ color: c.sims }}>Sims</span>
          <span
            className="absolute left-0 right-0 top-0 h-[1.5px] rounded-full"
            style={bar}
            aria-hidden="true"
          />
        </span>
      </span>
    </span>
  );
};

export default BrandLogo;
